'use strict';

var integrationCtrl = ['BuilderDataService', '$translate', '$state', function (BuilderDataService, $translate, $state) {
    var _this = this;
    this.isForValidator = this.isForValidator || false;
    this.integrationList = [];

    this.formLabel = () => $translate.instant('DASHBOARD.DASH_BUILDER.INTEGRATION_DIR.FORM');
    this.validatorLabel = () => $translate.instant('DASHBOARD.DASH_BUILDER.INTEGRATION_DIR.VALIDATOR');
    this.pageLabel = (pageIndex) => $translate.instant('DASHBOARD.DASH_BUILDER.INTEGRATION_DIR.PAGE') + ' ' + (pageIndex + 1);

    if (!this.element.integration) {
        this.element.integration = {
            id: null,
            dynamicParams: null,
        };
    }

    // recompatibilidad
    if (this.element.type == 'simplelist' && this.element.integration.userMode == undefined) {
        this.element.integration.userMode = true;
    }

    this.showTab = function (element) {
        let elementType = element.type == "sendemail" && element.templateData.asSelect ? 'select' : element.type;
        switch (elementType) {
            case 'select':
            case 'multiple':
            case 'validate':
            case 'docs':
            case 'photo':
            case 'simplelist':
            case 'qr':
            case 'populate':
                // case 'formula':
                return true;
            default:
                return false;
        }
    };

    this.filterIntegrations = function (element, integrations) {
        let elementType = element.type == "sendemail" && element.templateData.asSelect ? 'select' : element.type;
        return integrations.filter(function (integration) {
            if (integration.type === 'getData') {
                switch (elementType) {
                    case 'select':
                    case 'multiple':
                        return true;
                    default:
                        return false;
                }
            }
            if (integration.type === 'validate') {
                switch (element.type) {
                    case 'validate':
                        return true;
                    default:
                        return false;
                }
            }
            if (integration.type === 'populate') {
                switch (element.type) {
                    case 'simplelist':
                    case 'populate':
                    case 'docs':
                    case 'photo':
                    case 'qr':
                        return true;
                    default:
                        return false;
                }
            }
        });
    };

    this.showDynamicParams = function (integration) {
        if (!integration || !integration.configuration || !integration.configuration.connection) {
            return false;
        }
        if (!integration.configuration.connection.dynamicParams) {
            return false;
        }
        if (!Object.keys(integration.configuration.connection.dynamicParams).length) {
            return false;
        }
        return true;
    };

    this.showPopulateValues = function (integration) {
        if (!integration || !integration.configuration || !integration.configuration.connection) {
            return false;
        }
        if (integration.type !== 'populate') {
            return false;
        }

        if (!integration || !integration.configuration || !integration.configuration.populateValues) {
            return false;
        }

        if (!Object.keys(integration.configuration.populateValues).length) {
            return false;
        }
        return true;
    };

    this.getFlattenedInputElementsForForm = function (form, integration, init) {
        const processPages = function (pages, formType) {
            let flattenedElements = [];

            pages.forEach((page, pageIndex) => {
                const elementsWithLevels = _this.getElementsWithLevelsForFormDyn(page.fields, pageIndex, 1, formType);
                flattenedElements = flattenedElements.concat(elementsWithLevels);
            });
            return flattenedElements;
        };

        let flattenedPages = [];
        flattenedPages = processPages(form.pages, _this.formLabel());

        let flattenedElements = flattenedPages.filter(function (element) {
            if ((!["simplelist", "qr", "select", "docs", "photo"].includes(element.type)) && element.id === _this.element.id) {
                return false;
            }
            switch (element.type) {
                case 'text':
                case 'sendemail':
                case 'number':
                case 'select':
                case 'multiple':
                case 'formula':
                case 'simplelist':
                case 'group':
                case 'sign':
                case 'qr':
                case 'docs':
                case 'photo':
                case 'date':
                case 'time':
                case 'duration':
                case 'geo':
                case 'page':
                case 'autonumeric':
                    return true;
                default:
                    return false;
            }
        })
        if (init) {
            this.cleanElementDynParameters(flattenedElements, _this.element);
        }
        return flattenedElements;
    };

    this.getElementsWithLevelsForFormDyn = function (fields, pageIndex, level, formType) {
        return fields.flatMap(function (field) {
            const isElementInSimpleList = function (nodes) {
                return nodes.some(node => {
                    if (node.id === _this.element.id) {
                        return true;
                    }
                    if (node.nodes && node.nodes.length > 0) {
                        return isElementInSimpleList(node.nodes);
                    }
                    return false;
                });
            };

            if (field.type === 'simplelist') {
                const elementInCurrentSimpleList = field.id === _this.element.id || isElementInSimpleList(field.nodes || []);

                const currentField = {
                    ...field,
                    level: level,
                    disabled: false,
                    form: formType,
                    page: _this.pageLabel(pageIndex)
                };
                const nodesProcessed = elementInCurrentSimpleList
                    ? _this.getElementsWithLevelsForFormDyn(field.nodes, pageIndex, level + 1, formType)
                    : [];

                return [currentField].concat(nodesProcessed);
            }

            if (field.type === 'group') {
                const currentField = {
                    ...field,
                    level: level,
                    disabled: false,
                    form: formType,
                    page: _this.pageLabel(pageIndex)
                };
                const nodesProcessed = _this.getElementsWithLevelsForFormDyn(field.nodes, pageIndex, level + 1, formType);
                return [currentField].concat(nodesProcessed);
            }
            return [{ ...field, level: level, disabled: false, form: formType, page: _this.pageLabel(pageIndex) }];
        });
    };

    // La definición de un parámetro dinámico puede ser un objeto { value, fieldId, operation }.
    // El "Valor por defecto" del formulario es un texto. Al seleccionar la integración se toma
    // el .value del objeto; si es un valor directo se usa ese; si no hay nada, va vacío "".
    this.extractDefaultValue = function (paramDef, integration) {
        if (paramDef === undefined || paramDef === null) {
            return "";
        }
        if (typeof paramDef === 'object') {
            const selected = integration || _this.getSelectedIntegration();
            const isAi = selected && selected.configuration && selected.configuration.connection && selected.configuration.connection.urlType === 'ai';
            if (isAi && Object.prototype.hasOwnProperty.call(paramDef, 'defaultValue')) {
                return (paramDef.defaultValue === undefined || paramDef.defaultValue === null) ? "" : paramDef.defaultValue;
            }
            return (paramDef.value === undefined || paramDef.value === null) ? "" : paramDef.value;
        }
        return paramDef;
    };

    this.addMissingKeys = (target, source, integration) => {
        Object.keys(source || {}).forEach(key => {
            if (!target.hasOwnProperty(key)) {
                target[key] = _this.extractDefaultValue(source[key], integration);
            }
        });
    };

    // En valores devueltos, un "" guardado antes (cuando no se leía defaultValue)
    // se completa con el de la integración. Un valor que el usuario escribió se mantiene.
    this.fillEmptyPopulateDefaults = (target, source, integration) => {
        Object.keys(source || {}).forEach(key => {
            const current = target[key];
            const empty = current === undefined || current === null || current === "" || typeof current === 'object';
            if (empty) {
                target[key] = _this.extractDefaultValue(source[key], integration);
            }
        });
    };

    this.ensureIntegrationParamDefault = function (paramsKey, param) {
        _this.element.integration = _this.element.integration || {};
        if (!_this.element.integration[paramsKey] || typeof _this.element.integration[paramsKey] !== 'object') {
            _this.element.integration[paramsKey] = {};
        }
        var current = _this.element.integration[paramsKey][param];
        // Al reabrir: si está vacío (null/undefined) queda "". Si quedó el objeto entero,
        // se toma value, o defaultValue cuando la integración es IA.
        if (current === undefined || current === null) {
            _this.element.integration[paramsKey][param] = "";
        } else if (typeof current === 'object') {
            _this.element.integration[paramsKey][param] = _this.extractDefaultValue(current);
        }
    };

    this.cleanElementDynParameters = function (intElements, element) {
        const selectedIntegration = this.getSelectedIntegration();
        if (!selectedIntegration || !selectedIntegration.id) {
            console.error("No se encontró la integración seleccionada.");
            return;
        } else {
            // console.log('selectedIntegration', selectedIntegration);
            _this.element.integration.type = selectedIntegration.type;
            _this.element.integration.defaultParams = _this.element.integration.defaultParams || {};
        }
        const validDynamicParams = selectedIntegration.configuration.connection.dynamicParams;

        // Función para agregar claves faltantes en default

        this.addMissingKeys(_this.element.integration.defaultParams, validDynamicParams, selectedIntegration);

        // dynamicParams del element, limpiar
        if (typeof element?.integration?.dynamicParams === 'object' &&
            element.integration.dynamicParams !== null &&
            !Array.isArray(element.integration.dynamicParams))
            Object.keys(element.integration.dynamicParams).forEach(paramKey => {
                const paramValue = element.integration.dynamicParams[paramKey];
                const existsInIntegration = validDynamicParams.hasOwnProperty(paramKey);
                const existsInIntElements = paramValue?.trim() === "" || intElements.some(el => el.id === paramValue);
                if (!existsInIntegration || !existsInIntElements) {
                    delete element.integration.dynamicParams[paramKey];
                }
            });

        // console.log("Campos dinámicos limpios: ", element.integration.dynamicParams);
    };

    this.cleanElementPopulateParameters = function (intElements, element) {
        // console.log('intElements', intElements)
        // console.log('element', element)
        const selectedIntegration = this.getSelectedIntegration();
        if (!selectedIntegration || !selectedIntegration.id) {
            console.error("No se encontró la integración seleccionada.");
            return;
        } else {
            _this.element.integration.populateDefault = _this.element.integration.populateDefault || {};
        }
        const validPopulateParams = selectedIntegration.configuration.populateValues;

        this.fillEmptyPopulateDefaults(_this.element.integration.populateDefault, validPopulateParams, selectedIntegration);

        // populateValues: limpiar
        if (element.integration.populateValues) {
            Object.keys(element.integration.populateValues).forEach(paramKey => {
                const paramValue = element.integration.populateValues[paramKey];
                const existsInIntegration = validPopulateParams.hasOwnProperty(paramKey);
                const existsInIntElements = paramValue?.trim() === "" || intElements.some(el => el.id === paramValue);
                if (!existsInIntegration || !existsInIntElements) {
                    delete element.integration.populateValues[paramKey];
                }
            });
        }

        // console.log("Campos populate limpios: ", element.integration.populateValues);
    };

    this.getFlattenedInputElements = function (form, integration, dynamic) {
        const processPages = function (pages, formType) {
            let flattenedElements = [];

            pages.forEach((page, pageIndex) => {
                const elementsWithLevels = _this.getElementsWithLevels(page.fields, pageIndex, 1, formType, dynamic);
                flattenedElements = flattenedElements.concat(elementsWithLevels);
            });
            return flattenedElements;
        };

        // dynamic -> devuelve form y validation 
        // !dynamic -> devuelve validation 
        let flattenedPages = [];
        let flattenedValidatePages = [];
        if (dynamic) {
            flattenedPages = processPages(form.pages, _this.formLabel());
            flattenedValidatePages = processPages(form.validate_pages, _this.validatorLabel());
        } else {
            flattenedValidatePages = processPages(form.validate_pages, _this.validatorLabel());
        }

        return flattenedPages.concat(flattenedValidatePages).filter(function (element) {
            if ((!["simplelist", "qr", "select", "docs", "photo"].includes(element.type)) && element.id === _this.element.id) {
                return false;
            }
            switch (element.type) {
                case 'text':
                case 'sendemail':
                case 'number':
                case 'select':
                case 'multiple':
                case 'formula':
                case 'simplelist':
                case 'group':
                case 'sign':
                case 'qr':
                case 'docs':
                case 'photo':
                case 'date':
                case 'time':
                case 'duration':
                case 'geo':
                case 'page':
                    return true;
                default:
                    return false;
            }
        })
    };
    this.getElementsWithLevels = function (fields, pageIndex, level, formType, dynamic) {
        return fields.flatMap(function (field) {
            if (field.type === 'simplelist') {
                const currentField = {
                    ...field,
                    level: level,
                    disabled: false,
                    form: formType,
                    page: _this.pageLabel(pageIndex)
                };
                // NO SE PROCESAN LOS ELEMENTOS DENTRO DE SIMPLELIST CUANDO ES DYNAMIC
                // Procesar los nodos dentro del 'simplelist' después de 'simplelist'
                // if (!dynamic) {
                const nodesProcessed = _this.getElementsWithLevels(field.nodes, pageIndex, level + 1, formType, dynamic);
                return [currentField].concat(nodesProcessed);
                // } else {
                //     return [currentField];
                // }
            }
            if (field.type === 'group') {
                const currentField = {
                    ...field,
                    level: level,
                    disabled: false,
                    form: formType,
                    page: _this.pageLabel(pageIndex)
                };
                // Procesar los nodos dentro de 'group' despues de 'group'
                const nodesProcessed = _this.getElementsWithLevels(field.nodes, pageIndex, level + 1, formType);
                return [currentField].concat(nodesProcessed);
            }
            return [{ ...field, level: level, disabled: false, form: formType, page: _this.pageLabel(pageIndex) }];
        });
    };

    this.getFlattenedPopulateElements = function (form, integration, init) {
        const processPages = function (pages, formType) {
            let flattenedElements = [];

            pages.forEach((page, pageIndex) => {
                const elementsWithLevels = _this.getElementsWithLevelsForPopulate(page.fields, pageIndex, 1, formType);
                flattenedElements = flattenedElements.concat(elementsWithLevels);
            });
            return flattenedElements;
        };

        let lstFields = form.pages
        let flattenedPages = [];
        if (this.element.type == 'simplelist') {
            lstFields = [{ fields: this.element.nodes }];
            let el = JSON.parse(JSON.stringify(this.element));
            // Nombre a mostrar
            let listName = (el.name || el.label) + ' \(' + el.type + ' - ' + el.id + '\)';
            flattenedPages = processPages(lstFields, listName);
        } else {
            flattenedPages = processPages(lstFields, _this.formLabel());
        }

        let flattenedElements = flattenedPages.filter(function (element) {
            if (element.id === _this.element.id && _this.element.type !== 'photo') {
                return false;
            }
            switch (element.type) {
                case 'text':
                case 'sendemail':
                case 'autonumeric':
                case 'number':
                case 'select':
                case 'date':
                case 'time':
                case 'duration':
                case 'formula':
                case 'photo':
                case 'video':
                case 'docs':
                case 'timestamp':
                case 'checkbox':
                case 'multiple':
                case 'geo':
                case 'sign':
                case 'qr':
                case 'simplelist':
                case 'group':
                    return true;
                default:
                    return false;
            }
        })
        // this.cleanElementPopulateParameters(flattenedElements, JSON.parse(JSON.stringify(_this.element)));
        if (init) {
            this.cleanElementPopulateParameters(flattenedElements, _this.element);
        }
        return flattenedElements;
    };

    this.getElementsWithLevelsForPopulate = function (fields, pageIndex, level, formType) {
        return fields.flatMap(function (field) {
            // if (field.type === 'simplelist') {
            //     const currentField = {
            //         ...field,
            //         level: level,
            //         disabled: false,
            //         form: formType,
            //         page: _this.pageLabel(pageIndex)
            //     };
            //     // NO SE PROCESAN LOS ELEMENTOS DENTRO DE SIMPLELIST
            //     // Procesar los nodos dentro del 'simplelist' después de 'simplelist'
            //     // const nodesProcessed = _this.getElementsWithLevels(field.nodes, pageIndex, level + 1, formType);
            //     return [currentField];
            // }

            const isElementInSimpleList = function (nodes) {
                return nodes.some(node => {
                    if (node.id === _this.element.id) {
                        return true;
                    }
                    if (node.nodes && node.nodes.length > 0) {
                        return isElementInSimpleList(node.nodes);
                    }
                    return false;
                });
            };

            if (field.type === 'simplelist') {
                const elementInCurrentSimpleList = field.id === _this.element.id || isElementInSimpleList(field.nodes || []);

                const currentField = {
                    ...field,
                    level: level,
                    disabled: false,
                    form: formType,
                    page: _this.pageLabel(pageIndex)
                };
                const nodesProcessed = elementInCurrentSimpleList
                    ? _this.getElementsWithLevelsForFormDyn(field.nodes, pageIndex, level + 1, formType)
                    : [];

                return [currentField].concat(nodesProcessed);
            }

            if (field.type === 'group') {
                const currentField = {
                    ...field,
                    level: level,
                    disabled: false,
                    form: formType,
                    page: _this.pageLabel(pageIndex)
                };
                // Procesar los nodos dentro de 'group' despues de 'group'
                const nodesProcessed = _this.getElementsWithLevelsForPopulate(field.nodes, pageIndex, level + 1, formType);
                return [currentField].concat(nodesProcessed);
            }
            return [{ ...field, level: level, disabled: false, form: formType, page: _this.pageLabel(pageIndex) }];
        });
    };

    this.integrationSelected = function (integration) {
        if (!integration) {
            _this.element.integration = {};
        } else {
            const selectedIntegration = _this.integrations.filter(function (integr) {
                if (integration) {
                    return integr.id === integration;
                }
                return false;
            })[0];
            _this.element.integration = _this.element.integration || {};
            _this.element.integration.id = integration;
            _this.element.integration.type = selectedIntegration.type;
            const dynParams = selectedIntegration.configuration.connection.dynamicParams || {};
            _this.element.integration.defaultParams = Object.keys(dynParams).reduce(function (acc, key) {
                acc[key] = _this.extractDefaultValue(dynParams[key], selectedIntegration);
                return acc;
            }, {});
            const popParams = selectedIntegration.configuration.populateValues || {};
            _this.element.integration.populateDefault = Object.keys(popParams).reduce(function (acc, key) {
                acc[key] = _this.extractDefaultValue(popParams[key], selectedIntegration);
                return acc;
            }, {});
        }
        _this.element.integration.dynamicParams = {};
        _this.element.integration.populateValues = {};
    };

    this.openSelectedIntegration = () => {
        if (!_this.element.integration || !_this.element.integration.id) {
            return;
        }
        const hashUrl = $state.href('dashboard.integrations.integration', {
            integrationId: _this.element.integration.id
        });
        if (!hashUrl) {
            return;
        }
        // El builder se sirve en /app/. Una URL absoluta de ui-router queda en
        // el origen (/) y abre el sitio público, aunque el hash sea el correcto.
        const url = window.location.origin + window.location.pathname + hashUrl;
        window.open(url, '_blank');
    };

    this.getSelectedIntegration = function () {
        return _this.integrations.filter(function (integration) {
            if (_this.element.integration) {
                return integration.id === _this.element.integration.id;
            }
            return false;
        })[0];
    };

    this.integrations.unshift({
        name: '',
        id: null
    });

    // GET INPUT/POPULATE ELEMENTS FORM/VALIDATIONS
    if (this.isForValidator) {
        // Dyn
        this.inputElementsForValidationDyn = this.getFlattenedInputElements(this.form, _this.getSelectedIntegration(), true);
        // No Dyn
        this.inputElementsForValidationNoDyn = this.getFlattenedInputElements(this.form, _this.getSelectedIntegration(), false);
    } else {
        // Dyn
        this.inputElementsForForm = this.getFlattenedInputElementsForForm(this.form, _this.getSelectedIntegration(), true);
        // No Dyn
        this.inputElementsForPopulate = this.getFlattenedPopulateElements(this.form, _this.getSelectedIntegration(), true);
    }

    this.integrationList = _this.filterIntegrations(_this.element, _this.integrations);
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            element: '=',
            form: '=',
            integrations: '=',
            isForValidator: '='
        },
        replace: true,
        controller: integrationCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/integrationDirective.html'
    };
};
